import React from "react";
import "./NewsDataRow.css";

/**
 * Componente genérico para exibir “dados” com ícone + texto (empilhados).
 *
 * items: [{
 *   icon: ReactComponent | string (path),
 *   text?: string,             // texto simples
 *   list?: string[],           // modo "primeiro + (+N)" com tooltip das extras
 *   tooltipTitle?: string,     // título opcional dentro do tooltip
 * }]
 * title: string (opcional) – ex.: "Dados:"
 */
export default function NewsDataRow({ items = [], title = "Dados:", className = "" }) {
  return (
    <div className={`container-news-data-row ${className}`}>
      {!!title && <div className="title-news-data-row">{title}</div>}

      <div className="grid-news-data-row">
        {items.map((it, idx) => {
          const Icon = it.icon;
          const isPath = typeof Icon === "string";

          // suporte a list: mostra o primeiro + (+N)
          const hasList = Array.isArray(it.list) && it.list.length > 0;
          const baseText = it.text ?? (hasList ? it.list[0] : "—");
          const extra = hasList ? it.list.slice(1) : [];
          const extraCount = extra.length;

          return (
            <div key={idx} className="item-news-data-row">
              <span className="icon-wrap-news-data-row">
                {isPath ? (
                  <img src={Icon} alt="" className="icon-img-news-data-row" />
                ) : (
                  Icon && <Icon className="icon-svg-news-data-row" />
                )}
              </span>

              <span className="text-wrap-news-data-row">
                <span className="text-news-data-row">{baseText}</span>

                {extraCount > 0 && (
                  <span className="extra-wrap-news-data-row">
                    <span className="extra-count-news-data-row">(+{extraCount})</span>

                    {/* Tooltip com as demais entradas */}
                    <div className="tooltip-news-data-row">
                      {it.tooltipTitle && (
                        <div className="tooltip-title-news-data-row">{it.tooltipTitle}</div>
                      )}
                      <ul className="tooltip-list-news-data-row">
                        {extra.map((val, i) => (
                          <li key={i} className="tooltip-item-news-data-row">{val}</li>
                        ))}
                      </ul>
                    </div>
                  </span>
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
